module.exports = __webpack_public_path__ + "static/logo-ceb3ec528e17aa51d4bf72c6e39b1ca9.png";